import { Reveal } from "@/lib/motion";
import { FOUNDER } from "@/data/content";
import { Globe, ArrowRight } from "lucide-react";

export default function Founder({ onBook }) {
  return (
    <section className="relative z-10 py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="relative">
            <div className="absolute -inset-3 rounded-3xl bg-blue-50" />
            <img
              src={FOUNDER.image}
              alt="WebsiteTech founder"
              loading="lazy"
              className="relative w-full h-[440px] object-cover rounded-2xl soft-shadow-lg"
            />
            <div className="absolute bottom-4 left-4 bg-white rounded-xl soft-shadow px-4 py-2">
              <span className="overline">Founder & Principal</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <span className="overline">From programming to AI platforms</span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mt-3">
            Decades of building, publishing & shipping.
          </h2>
          <p className="text-slate-500 text-lg leading-relaxed mt-6">{FOUNDER.bio}</p>

          <div className="mt-8 bg-slate-50 border border-slate-200 rounded-2xl p-6">
            <div className="flex items-center gap-2 mb-2">
              <Globe size={16} className="text-brand" />
              <span className="overline">Website Development Without Borders</span>
            </div>
            <p className="text-slate-600">
              Work with WebsiteTech from anywhere in the world — with support for your country,
              currency, time zone, language and remote consultations.
            </p>
            <button onClick={onBook} className="btn-primary rounded-xl px-6 py-3 mt-5 flex items-center gap-2">
              Book a Strategy Session <ArrowRight size={15} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
